<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg6 sm6>
        <v-layout row wrap pa-3>
          <v-flex lg4 sm12 py-0>
            <v-select
              v-if="currentItem.ID == 0"
              label="Mã bao hàng"
              class="input-group--focused pt-0"
              :items="packages"
              v-model="currentItem.ID"
              item-text="PackageCode"
              item-value="ID"
              :disabled="readOnly"
              :rules="[(v) => !!v || 'Hãy nhập mã bao hàng']"
              @change="onChangePackage"
            >
            <template slot="no-data">
              <div>Không có dữ liệu bao hàng nhập kho</div>
            </template>
            </v-select>
            <v-text-field
              v-if="currentItem.ID > 0"
              label="Mã bao hàng"
              v-model="currentItem.PackageCode"
              class="input-group--focused pt-0"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex lg8 sm12 py-0>
          </v-flex>
          <v-flex lg4 sm12 py-0 pt-3>
            <mh-date-picker plabel="Ngày nhập kho" class="input-group--focused date-picker px-3" prependIcon="" v-model="import_date" @onChangeDate="import_date =$event; saveData();"></mh-date-picker>
          </v-flex>
          <v-flex lg4 sm12  py-0>
            <h-currency-input
              label="Tổng phí ship"
              v-model="currentItem.Amount"
              :decimal="0"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 sm12  py-0>
          </v-flex>
          <v-flex lg4 sm12  py-0>
            <h-currency-input
              label="Số kiện (TQ)"
              v-model="currentItem.Volume"
              :decimal="0"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 sm12 py-0>
            <h-currency-input
              label="Số kiện đã nhập"
              v-model="currentItem.ReceivedPacks"
              :decimal="0"
              showClass="input-group--focused font-weight-bold text-red"
              color="red darken-2"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 sm12 py-0>
          </v-flex>
          <v-flex lg4 sm12 py-0>
            <v-text-field
              label="Tổng cân nặng (TQ)"
              type="number"
              v-model="currentItem.Weight"
              class="input-group--focused"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex lg4 sm12 py-0>
            <v-text-field
              label="Tổng cân nặng đã nhập"
              type="number"
              v-model="currentItem.ReceivedWeight"
              class="input-group--focused font-weight-bold text-red"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex lg4 sm12 py-0>
          </v-flex>
          <v-flex lg8 sm12 py-0>
            <v-text-field
              label="Cân nặng thực tế"
              type="number"
              step=".1"
              v-model="currentItem.RealWeight"
              class="input-group--focused font-weight-bold"
              @change="saveData"
            ></v-text-field>
          </v-flex>
          <v-flex lg12 md12 sm12 py-0>
            <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
          </v-flex>
          <v-flex lg12 md12 sm12 py-0>
            <v-text-field
              label="Mã vận đơn"
              ref="trancode"
              v-model.lazy="transactionCode"
              class="input-group--focused pt-0"
              @input="codeChanged"
              @keyup.enter="manualChanged"
              :disabled="readOnly"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg6 sm6>
        <v-widget title="Danh sách kiện">
          <div slot="widget-header-action">
              <v-btn @click="appendDetail">
                  <v-icon color="red darken-3">fa-plus</v-icon>
              </v-btn>
          </div>
          <div slot="widget-content">
            <v-data-table
              :headers="detail_headers"
              :items="details"
              :items-per-page="5"
              :footer-props="{ 'items-per-page-options': [5, 10, 20] }"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <v-edit-dialog :return-value.sync="item.ProductType" large lazy persistent @save="saveDetail({ID: item.ID, ProductType: item.ProductType})">
                      <div>{{ item.ProductType | display_value(config_producttypes)}}</div>
                      <template v-slot:input>
                        <v-select
                          v-model="item.ProductType"
                          :items="config_producttypes"
                          label="Loại hàng"
                          item-text="name"
                          item-value="value"
                          single-line
                          autofocus
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy persistent @save="saveDetail({ID: item.ID, NumberOfPack: item.NumberOfPack})">
                      <div>{{ item.NumberOfPack | currency }}</div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.NumberOfPack"
                          type="number"
                          label="Số kiện"
                          step="1"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.Weight" large lazy persistent @save="saveDetail({ID: item.ID, Weight: item.Weight})">
                      <div>{{ item.Weight | currency('', 2) }}</div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.Weight"
                          type="number"
                          label="Cân nặng"
                          step=".01"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.Length" large lazy persistent @save="saveDetail({ID: item.ID, Length: item.Length})">
                      <div>{{ item.Length | currency }}</div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.Length"
                          type="number"
                          label="Chiều dài"
                          step="1"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.Width" large lazy persistent @save="saveDetail({ID: item.ID, Width: item.Width})">
                      <div>{{ item.Width | currency }}</div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.Width"
                          type="number"
                          label="Chiều rộng"
                          step="1"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">
                    <v-edit-dialog :return-value.sync="item.Height" large lazy persistent @save="saveDetail({ID: item.ID, Height: item.Height})">
                      <div>{{ item.Height | currency }}</div>
                      <template v-slot:input>
                        <v-text-field
                          v-model="item.Height"
                          type="number"
                          label="Chiều cao"
                          step="1"
                          single-line
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </td>
                  <td class="text-end">{{ item.Volume | currency('', 6) }}</td>
                  <td class="text-center">
                    <v-icon small @click="deleteDetail(item.ID)">fa-trash-alt</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
    <v-layout row wrap pa-3>
      <v-flex lg12 md12 sm12 pa-0>
        <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
        <v-data-table
          :headers="headers"
          :items="currentItem.Packages"
          :options.sync="pagination"
          :server-items-length="currentItem.Packages ? currentItem.Packages.length : 0"
          :footer-props="items_per_page"
          :must-sort="true"
          :loading="loading"
          :mobile-breakpoint="100"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
              <td class="text-end">{{ item.FeeShip | currency}}</td>
              <td>{{ (item.PackageType === 1 ? 'KG' : 'MD') +item.OrderID }}</td>
              <td>{{ item.Username }}</td>
              <td class="text-end" v-if="item.Status == 5 && !adminRole">{{ item.Weight}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Weight"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Weight}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Weight"
                      type="number"
                      label="Cân nặng"
                      step=".1"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5 && !adminRole">{{ item.RealNumberOfPack}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.RealNumberOfPack"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.RealNumberOfPack}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.RealNumberOfPack"
                      type="number"
                      label="Số kiện"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5 && !adminRole">{{ item.Length}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Length"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Length}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Length"
                      type="number"
                      label="Chiều dài (cm)"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5 && !adminRole">{{ item.Width}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Width"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Width}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Width"
                      type="number"
                      label="Chiều rộng (cm)"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5 && !adminRole">{{ item.Height}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Height"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Height}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Height"
                      type="number"
                      label="Chiều cao (cm)"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end">{{ item.Volume | currency('', 3)}}</td>
              <td class="text-end">{{ item.WeightByVolume | currency('', 1)}}</td>
              <td class="truncate">
                <v-tooltip top max-width="250" color="light-blue lighten-2 black--text">
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{ item.StoreCNNote }}</span>
                    </template>
                    <span>{{ item.StoreCNNote }}</span>
                </v-tooltip>
              </td>
              <td class="truncate">
                <v-edit-dialog
                :return-value.sync="item.StoreVNNote"
                large
                lazy
                persistent
                @save="saveNoteItem(item)"
                >
                    <v-tooltip max-width="250" color="light-green lighten-5 black--text">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">{{ item.StoreVNNote }}</span>
                        </template>
                        <span>{{ item.StoreVNNote }}</span>
                    </v-tooltip>
                    <template v-slot:input>
                        <v-textarea
                        v-model="item.StoreVNNote"
                        label="Ghi chú"
                        autofocus
                        ></v-textarea>
                    </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-icon :disabled="!adminRole" small @click="deleteTransaction(item)">fa-trash-alt</v-icon>
                <!-- <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.Weight, item.WeightByVolume, item.Length, item.Width, item.Height, item.TransactionCode, item.Username, item.OrderID, item.NumberOfCode)">fa-print</v-icon> -->
              </td>
            </tr>
          </template>
          <template v-slot:body.append v-if="currentItem.PackageSummary">
            <tr class="table-summary">
                <td class="font-weight-bold" colspan="4">TỔNG</td>
                <td class="font-weight-bold text-end">{{ currentItem.PackageSummary.Weight | currency('',1)}}</td>
                <td class="font-weight-bold text-end">{{ currentItem.PackageSummary.RealNumberOfPack | currency}}</td>
                <td class="font-weight-bold text-end"></td>
                <td class="font-weight-bold text-end"></td>
                <td class="font-weight-bold text-end"></td>
                <td class="font-weight-bold text-end">{{ currentItem.PackageSummary.Volume | currency('',3)}}</td>
                <td class="font-weight-bold text-end">{{ currentItem.PackageSummary.WeightByVolume | currency('',1)}}</td>
                <td class="font-weight-bold text-end"></td>
                <td class="font-weight-bold text-end"></td>
                <td class="font-weight-bold text-end"></td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VWidget from "@/components/VWidget";
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import _ from "lodash";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { print_transaction } from "@/commons/hpod";
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
export default {
  components: {
    VWidget,
    "hpo-filter": Filtering,
    "mh-date-picker": MHDatePicker
  },
  data() {
    return {
      appLoading: false,
      useBarcodeReader: true,
      transactionCode: "",
      detail_headers: [
        {
          text: "Loại hàng",
          value: "ProductType"
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
        },
        {
          text: "Kg",
          value: "Weight",
          align: "end",
        },
        {
          text: "Dài",
          value: "Length",
          align: "end",
        },
        {
          text: "Rộng",
          value: "Width",
          align: "end",
        },
        {
          text: "Cao",
          value: "Height",
          align: "end",
        },
        {
          text: "M³",
          value: "Volume",
          align: "end",
        },
        {
          text: "Thao tác",
          value: "",
          width: 100
        }
      ],
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Order ID",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Số kiện",
          value: "RealNumberOfPack",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều dài (cm)",
          value: "Length",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều rộng (cm)",
          value: "Width",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều cao (cm)",
          value: "Width",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Khối",
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cân quy đổi",
          value: "WeightByVolume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú TQ",
          value: "StoreCNNote",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Ghi chú",
          value: "StoreVNNote",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: {...configs.PAGINATION,  sortBy: ["ID"] },
      items_per_page: {...configs.ITEMS_PER_PAGE},
      currentTime: getCurrentTime(),
      showDialogTrancode: false,
      newTransactionCode: '',
      viewName: 'detail_bigpackage',
      filterConditions: [],
      quickFilterConditions: [],
      import_date: null
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : [];
        this.refreshData();
      },
      deep: true
    },
    packageId() {
      if(this.packageId > 0) {
        this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
          Pid: this.packageId,
          title: "Chi tiết nhập kho"
        }
      });
      this.refreshData();
      }
      this.appLoading = false;
    },
    currentItem() {
      if(this.currentItem) {
        this.import_date = this.currentItem.ImDate ? moment(this.currentItem.ImDate).toISOString().substr(0, 10) : null;
      }
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      totalPackage: state => {
        state.bigPackage.selected.Packages
          ? state.bigPackage.selected.Packages.length
          : 0;
      },
      loading: state => state.bigPackage.loading,
      trancodeDetail: state => state.bigPackage.trancodeDetail,
      packages: state => state.bigPackage.notTransit,
      details: state => state.bigpackageDetail.all.data,
      configuration: state => state.configuration.selected,
    }),
    packageId() {
      return this.currentItem && this.currentItem.ID > 0
        ? this.currentItem.ID
        : Number(this.$route.params.Pid);
    },
    trancode_param() {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      var param = {
        pagination: {
          ...configPaging,
          itemsPerPage: 1000000
        },
        'trancode': this.transactionCode
      };
      return param;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    config_producttypes() {
      return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
    }
  },
  mounted() {
    this.refreshData();
    this.getListPackageNotTran();
    this.$store.dispatch("configuration/getDetail", 1);
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
          data: {
            'RequestAction': 'DEL',
            'TransactionView': 'store_vn'
          },
          'id': id,
          param: {}
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
  },
  methods: {
    printTransaction(weight, weight_v2, length, width, height, transactionCode, customerName, orderId, numberOfCode) {
        print_transaction(weight, weight_v2, length, width, height, transactionCode, customerName, orderId, numberOfCode);
    },
    manualChanged() {
      if (!this.useBarcodeReader) {
        this.refreshData();
      }
    },
    codeChanged() {
      if (this.useBarcodeReader) {
        this.refreshData();
      }
    },
    refreshData() {
      if (this.packageId) {
        let pr = {
          pagination: { ...this.pagination, itemsPerPage: 1000000 },
          filter: [...this.filterConditions],
          quickFilter: [...this.quickFilterConditions]
        };
        if(this.transactionCode.trim() != '') {
          pr.filter.push({
            column: "TransactionCode",
            value: this.transactionCode.trim(),
            condition: "contain"
          });
        }
        this.$store.dispatch("bigPackage/getDetail", {'id': this.packageId, 'param': pr});
        this.$store.dispatch("bigpackageDetail/getList", {filter: [{column: 'BigpackageID', value: this.packageId, condition: 'equal'}]});
      }
    },
    onChangePackage(value) {
      this.appLoading = true;
      let selectedItem = _.find(this.packages, { ID: value });
      if (selectedItem) {
        this.currentItem.PackageCode = selectedItem.PackageCode;
      }
      this.saveData();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    saveTranWeight(item) {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      this.editTransCode(item);
    },
    saveNoteItem(item) {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      this.$store.dispatch("orderTransaction/setDetail", {'data': {'StoreVNNote': item.StoreVNNote}, 'id': item.ID});
    },
    deleteTransaction(item) {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      if(item.Status == 5) {
        sendErrorNotice("Mã vận đơn đã giao hàng!");
        return;
      }
      window.getApp.$emit('REQUEST_DELETE_DATA', item.ID);
    },
    createData(username = "") {
      this.getListPackageNotTran();
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập bao mới'
          }
      });
    },
    saveData() {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ReceivedWeight: this.currentItem.ReceivedWeight,
          RealWeight: this.currentItem.RealWeight,
          ReceivedPacks: this.currentItem.ReceivedPacks,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.NHAP_KHO_VN,
          ImDate: this.import_date ? moment(this.import_date, 'YYYY-MM-DD').add(7, 'hours').format(configs.SQL_DATE_FORMAT) : null,
        },
        id: this.currentItem.ID
      });
      this.appLoading = false;
    },
    editTransCode: _.debounce(
      function(item) {
        var data = {
          ID: item.ID,
          RealNumberOfPack: item.RealNumberOfPack,
          Weight: item.Weight,
          Length: item.Length,
          Width: item.Width,
          Height: item.Height,
          BigPackageId: item.BigPackageId,
          TransactionView: 'store_vn'
        };
        data.ModifiedBy = this.$store.state.authentication.user.username;
        this.$store.dispatch("orderTransaction/setDetail", { 'data': data, 'id': item.ID});
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    dialogTrancode() {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      this.showDialogTrancode = true;
    },
    saveNewTrancode() {
      if(this.currentItem.Locked && !this.adminRole) {
        sendErrorNotice("Bao hàng đã khóa, liên hệ admin để chỉnh sửa!");
        return;
      }
      this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.newTransactionCode, 'package_id': this.packageId, 'param': this.trancode_param});
      this.newTransactionCode = '';
      this.showDialogTrancode = false;
    },
    applyFilter(filterConditions) {
        let sortBy = this.pagination.sortBy
        let sortDesc = this.pagination.sortDesc
        this.pagination = configs.PAGINATION;
        this.pagination.sortBy = sortBy;
        this.pagination.sortDesc = sortDesc;
        this.filterConditions = filterConditions;
        this.refreshData();
    },
    quickFilter(filterConditions) {
        this.quickFilterConditions = filterConditions;
        this.refreshData();
    },
    saveDetail(item) {
      this.$store.dispatch("bigpackageDetail/setDetail", { 'data': item, 'id': item.ID});
    },
    appendDetail() {
      this.$store.dispatch("bigpackageDetail/setDetail", { 'data': {'BigpackageID': this.packageId}, 'id': 0});
    },
    deleteDetail(id) {
      this.$store.dispatch("bigpackageDetail/removeDetail", id);
    }
  }
};
</script>
